/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle Export" |
*
* @param {Subtitle_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_title = /** @type {((inputs?: Subtitle_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕エクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar legenda")
	return /** @type {LocalizedString} */ ("Subtitle Export")
});